import { useTenant } from './useTenant';

/** Company-wide default markup applied to part cost to get the customer sell price. */
export function usePartsMarkup(): number {
  const { company } = useTenant();
  return company?.parts_markup_pct ?? 0;
}

export type PartSource = 'company_stock' | 'tech_personal';

/** Company-wide default for "who paid for the part", preselected when a part is added to a job. */
export function useDefaultPartSource(): PartSource {
  const { company } = useTenant();
  return company?.default_part_source === 'tech_personal' ? 'tech_personal' : 'company_stock';
}
